export { h, Fragment } from 'preact';
export { Buffer } from 'buffer';

import process from 'process';

export { process };

